import { Divider, useMediaQuery } from '@mui/material';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import dynamic from 'next/dynamic';

const SettingBox = dynamic(() => import('../game-settings'), {
  ssr: false,
});
const RingGameBox = dynamic(() => import('./RingGameBox'), {
  ssr: false,
});

import RingGameInfo from './RingGameInfo';

const RingWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
}));
const StyledRingContent = styled(Box)(({ theme }) => ({
  width: '100%',
  flex: 1,
  display: 'flex',
  gap: '20px',
  background: theme.palette.bg.main,
  [theme.breakpoints.down('md')]: {
    minHeight: 'auto',
  },
}));

export default function RingGame() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  return (
    <Box>
      <RingWrapper className={'ring-wrapper'}>
        <StyledRingContent>
          <RingGameBox />
        </StyledRingContent>
      </RingWrapper>
      <Box
        sx={{
          mt: 2.5,
        }}
      >
        <SettingBox
          isMob={isMobile}
          gameId={'ring'}
          fairnessLink={'/ring/fairness'}
        />
      </Box>
      <RingGameInfo />
    </Box>
  );
}
